const userLocation = (state = {} , action) => {
    switch(action.type) {
        case 'LOCATION' :
            return state = action.payload;
        default : 
            return state = {};
    }
}
export default userLocation;